/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from 'react';
import { Bar } from 'react-chartjs-2';
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../../Constants";

const Report = () => {

    const [report, setReport] = useState([])
    const getReport = () =>{
        axios.post(BASEURL+'/api/dashboard/get-dashboard-data', date).then(res=>{
            setReport(res.data)
        })
    }
    useEffect(() => {
        getReport()
    }, []);


    const [date, setDate] = useState([])
    const handleDateInput = (e) => {
       setDate(prev =>({...prev, [e.target.name] :e.target.value }))
    }
    const handleSearch = () => {
        setDate(prev =>({...prev, time: 'between' }))
        getReport()
    }

    const handleButtonInput = (e, time) => {
        if (time == 'all'){
            setDate(prev =>({...prev, time: 'all' }))
        }else if(time=='this'){
            setDate(prev =>({...prev, time: 'this' }))
        }else if(time=='prev'){
            setDate(prev =>({...prev, time: 'prev' }))
        }
    }

    useEffect(()=>{
        getReport()
    }, [date.time])


    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Report</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Report</li>
                </ol>
                <div className="my-card text-center">
                    <div className="row">
                        <div className="col-md-6 text-start mb-1">
                            <button onClick={(e)=>handleButtonInput(e, 'all')} className={'btn btn-success btn-sm'}>All Time</button>
                            <button onClick={(e)=>handleButtonInput(e, 'this')} className={'btn btn-success btn-sm ms-1'}>This Month</button>
                            <button onClick={(e)=>handleButtonInput(e, 'prev')} className={'btn btn-success btn-sm ms-1'}>Previous Month</button>
                        </div>
                        <div className="col-md-6 text-end mb-1">
                            <div className="row align-items-center">
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'start_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'end_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-2">
                                    <button onClick={handleSearch} className={'btn btn-success btn-sm ms-1'}>Search</button>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card bg-primary text-white">
                                                <div className="card-header">
                                                    <h5>Total Order Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_order_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Paid Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_paid_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-warning text-white">
                                                <div className="card-header">
                                                    <h5>Total Due Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_due_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-5">
                                        <div className="col-md-3">
                                            <div className="card bg-info text-white">
                                                <div className="card-header">
                                                    <h5>Total Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-dark text-white">
                                                <div className="card-header">
                                                    <h5>Pending</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.pending_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Processing</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.processing_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-danger text-white">
                                                <div className="card-header">
                                                    <h5>Canceled</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.canceled_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Delivered Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.delivered_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="row mt-5 pb-5">*/}
                                    {/*    <div className="col-md-6">*/}
                                    {/*        <Bar*/}
                                    {/*            data={data}*/}
                                    {/*            width={50}*/}
                                    {/*            height={50}*/}
                                    {/*            options={{ maintainAspectRatio: true }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-md-6">*/}
                                    {/*        <Bar*/}
                                    {/*            data={data}*/}
                                    {/*            width={50}*/}
                                    {/*            height={50}*/}
                                    {/*            options={{ maintainAspectRatio: true }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
};

export default Report;
